module.exports = __webpack_public_path__ + "static/media/Malina.fadaa8d0.jpg";